"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nullTasks = void 0;
var NULL_TASKS_EVENT_NAME = 'nullTasks';
var nullTasks = function () {
    return {
        event: NULL_TASKS_EVENT_NAME,
        eventInfo: NULL_TASKS_EVENT_NAME,
    };
};
exports.nullTasks = nullTasks;
